import React from "react"
import { css } from "@emotion/react"
import { StaticImage } from "gatsby-plugin-image"

import AnimatedSection from "../animated-section"
import theme from "../../styles/theme"

const Network = ({ className }) => {
  return (
    <AnimatedSection
      inverted
      className={className}
      leftElement={
        <div>
          <h2 className="dark text-sm-center">
            <em className="variant">Connecter</em> les acteurs du circuit
          </h2>
          <p className="margin-bottom-sm">
            Ensemble, nous construisons le réseau de demain en rapprochant tous
            les acteurs de l’économie circulaire : de la matière première au
            producteur.
          </p>
        </div>
      }
      rightElement={
        <StaticImage
          imgStyle={{
            borderRadius: theme.shape.borderRadius[0],
            boxShadow: theme.elevation.level2,
          }}
          css={css`
            border-radius: ${theme.shape.borderRadius[0]};
            box-shadow: ${theme.elevation.level2};
          `}
          placeholder="blurred"
          width={450}
          src="../../images/index_network_shop.jpg"
          alt=""
        />
      }
    />
  )
}

export default Network
